import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxImageUploader from "src/components/images/SfxImageUploader.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import { getTranslatedEntityForPage } from "src/util/functions/entity"
import { saveIssueOnItemComment } from "src/util/functions/issues"
import {
  saveCorrectiveWorkOnItemComment,
  saveRegularWorkOnItemComment,
} from "src/util/functions/performedWork"
import {
  saveWorkOrderCorrectiveItemComment,
  saveWorkOrderRegularItemComment,
} from "src/util/functions/workOrder"
import { AttachmentContext, AttachmentUpload } from "src/util/types/dataModels/attachment"
import { EntityPages } from "src/util/types/dataModels/entityDefinition"
import { computed, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogAddComment',
  props: {
  entity: {
    type: String as PropType<EntityPages>,
    required: true,
  },

  entityId: {
    type: String,
    required: true,
  },

  attachmentContext: {
    type: String as PropType<AttachmentContext>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const translatedEntity = computed(() => getTranslatedEntityForPage(props.entity))

const titleAddComment = t("sfxDialogAddComment.title_add_comment_to_entity", {
  entity: translatedEntity.value,
})
const labelAddComment = t("sfxDialogAddComment.label_add_comment_and_photos")
const labelComment = t("sfxDialogAddComment.label_comment")
const btnCancel = t("sfxButtons.btn_cancel")
const btnConfirm = t("sfxButtons.btn_confirm")

const comment = ref<string>()
const uploadedImages = ref<AttachmentUpload[] | undefined>()

//endregion

async function addComment(attachmentContext: AttachmentContext) {
  if (!comment.value) return

  switch (attachmentContext) {
    case "issue_item_comment":
      const issueItemComment = await saveIssueOnItemComment(
        props.entityId,
        comment.value,
        uploadedImages.value
      )
      if (issueItemComment) onDialogOK(issueItemComment)

      break

    case "corrective_work_item_comment":
      const correctiveWorkItemComment = await saveCorrectiveWorkOnItemComment(
        props.entityId,
        comment.value,
        uploadedImages.value
      )
      if (correctiveWorkItemComment) onDialogOK(correctiveWorkItemComment)

      break

    case "regular_work_item_comment":
      const regularWorkItemComment = await saveRegularWorkOnItemComment(
        props.entityId,
        comment.value,
        uploadedImages.value
      )
      if (regularWorkItemComment) onDialogOK(regularWorkItemComment)

      break

    case "work_order_corrective_item_comment":
      const workOrderCorrectiveItemComment = await saveWorkOrderCorrectiveItemComment(
        props.entityId,
        comment.value,
        uploadedImages.value
      )
      if (workOrderCorrectiveItemComment) onDialogOK(workOrderCorrectiveItemComment)

      break

    case "work_order_regular_item_comment":
      const workOrderRegularItemComment = await saveWorkOrderRegularItemComment(
        props.entityId,
        comment.value,
        uploadedImages.value
      )
      if (workOrderRegularItemComment) onDialogOK(workOrderRegularItemComment)

      break
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(titleAddComment)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1 q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(labelAddComment)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pb-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxInput, {
                modelValue: comment.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event)),
                label: _unref(labelComment),
                required: "",
                "hide-bottom-space": ""
              }, null, 8, ["modelValue", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pb-none" }, {
            default: _withCtx(() => [
              _createVNode(SfxImageUploader, {
                "uploaded-images": uploadedImages.value,
                "onUpdate:uploadedImages": _cache[1] || (_cache[1] = ($event: any) => ((uploadedImages).value = $event))
              }, null, 8, ["uploaded-images"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                label: _unref(btnCancel),
                class: "col q-mr-sm",
                onClick: _unref(onDialogCancel)
              }, null, 8, ["label", "onClick"]),
              _createVNode(SfxBtn, {
                label: _unref(btnConfirm),
                class: "col",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addComment(props.attachmentContext))),
                disable: !comment.value
              }, null, 8, ["label", "disable"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})